var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.915 3.08476C11.4071 2.57685 10.7183 2.2915 9.99996 2.2915C9.28166 2.2915 8.59279 2.57685 8.08488 3.08476C7.57697 3.59267 7.29163 4.28154 7.29163 4.99984C7.29163 5.34502 7.0118 5.62484 6.66663 5.62484C6.32145 5.62484 6.04163 5.34502 6.04163 4.99984C6.04163 3.95002 6.45866 2.9432 7.20099 2.20087C7.94333 1.45854 8.95014 1.0415 9.99996 1.0415C11.0498 1.0415 12.0566 1.45854 12.7989 2.20087C13.5413 2.9432 13.9583 3.95002 13.9583 4.99984V8.5415H14.1666C15.4323 8.5415 16.4583 9.56752 16.4583 10.8332V15.8332C16.4583 17.0988 15.4323 18.1248 14.1666 18.1248H5.83329C4.56764 18.1248 3.54163 17.0988 3.54163 15.8332V10.8332C3.54163 9.56752 4.56764 8.5415 5.83329 8.5415H12.7083V4.99984C12.7083 4.28154 12.423 3.59267 11.915 3.08476ZM13.3333 9.7915H5.83329C5.258 9.7915 4.79163 10.2579 4.79163 10.8332V15.8332C4.79163 16.4085 5.258 16.8748 5.83329 16.8748H14.1666C14.7419 16.8748 15.2083 16.4085 15.2083 15.8332V10.8332C15.2083 10.2579 14.7419 9.7915 14.1666 9.7915H13.3333ZM9.99996 14.1665C10.4602 14.1665 10.8333 13.7934 10.8333 13.3332C10.8333 12.8729 10.4602 12.4998 9.99996 12.4998C9.53972 12.4998 9.16663 12.8729 9.16663 13.3332C9.16663 13.7934 9.53972 14.1665 9.99996 14.1665Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b4c1c7edd98ecae58c0debd87b385ff6.svg";
export { ForwardRef as ReactComponent };